import { EXTENSION_SECRET_KEY } from "@faire/web--source/common/consts/EXTENSION_SECRET_KEY";
import { HASHED_SESSION_TOKEN_KEY } from "@faire/web--source/common/consts/HASHED_SESSION_TOKEN_KEY";
import Cookies from "js-cookie";
// According to the GDPR’s definition of persistent cookies, set for 12 months
var COOKIE_EXPIRES_IN_DAYS = 365;
export var toggleCookie = function(key, value) {
    if (value) {
        setCookies(key, value);
    } else {
        removeCookie(key);
    }
};
export var setCookies = function(key, value) {
    if (key === HASHED_SESSION_TOKEN_KEY || key === EXTENSION_SECRET_KEY) {
        var now = new Date();
        var threeMinutesLater = new Date(now.getTime() + 3 * 60 * 1000);
        Cookies.set(key, value, {
            expires: threeMinutesLater
        });
    } else {
        Cookies.set(key, value, {
            expires: COOKIE_EXPIRES_IN_DAYS
        });
    }
};
export var getCookies = function(key) {
    return Cookies.get(key);
};
export var removeCookie = function(key) {
    return Cookies.remove(key);
};
